/* tslint:disable */
/* eslint-disable */
/**
 * Selling Partner API for Fulfillment Inbound
 * The Selling Partner API for Fulfillment Inbound lets you create applications that create and update inbound shipments of inventory to Amazon\'s fulfillment network.
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * Where the seller provided box contents information for a shipment.
 */

export const BoxContentsSource = {
    None: 'NONE',
    Feed: 'FEED',
    _2DBarcode: '2D_BARCODE',
    Interactive: 'INTERACTIVE',
} as const;

export type BoxContentsSource = typeof BoxContentsSource[keyof typeof BoxContentsSource];



